<template>
	<div class="container page">
		<van-nav-bar :title="$t('setting.login_pwd_tip')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
			<template #right>
				<span class="nav-right" @click="save()">{{$t("setting.save")}}</span>
			</template>
		</van-nav-bar>
		<van-cell-group>
			<van-field v-model="old_password" :label="$t('other.old_password')" :placeholder="$t('setting.old_pwd_tip')" />
			<van-field v-model="o_new_password" :label="$t('other.new_password')" :placeholder="$t('other.new_password')" />
			<van-field v-model="t_new_password" :label="$t('other.new_password')" :placeholder="$t('other.new_password')" />
		</van-cell-group>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				o_new_password: "",
				t_new_password: "",
				old_password: "",
			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			save() {
				this.$http({
					method: 'post',
					data: {
						oldpassword: this.old_password,
						newpassword: this.o_new_password,
					},
					url: 'resetpwd'
				}).then(res => {
					if (res.code == 1) {
						this.$toast(res.msg);
						setTimeout(() => {
							localStorage.clear()
							this.$router.push("Login")
						}, 500);
					} else {
						this.$toast(res.msg);
					}
				})
			},
		},
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	.van-cell {
		font-size: 35px;
		line-height: 80px;
	}
</style>